import { useTranslation } from 'react-i18next';

import { RoamlerLogo } from '@/components/blocks/shared/roamler-logo';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { LoginForm } from '@/routes/(auth)/components/login-form';

const Login = () => {
  const { t } = useTranslation();

  return (
    <div className='flex flex-col items-center gap-8'>
      <div className='flex flex-col items-center gap-3'>
        <RoamlerLogo className='text-foreground h-10 w-auto' />
        <p className='text-muted-foreground text-sm font-medium tracking-wide uppercase'>
          {t('auth.login.appName')}
        </p>
      </div>
      <Card className='border-border w-full gap-6 py-8 shadow-lg'>
        <CardHeader className='text-center'>
          <CardTitle className='text-xl'>{t('auth.login.title')}</CardTitle>
          <CardDescription className='px-0 pb-0'>
            {t('auth.login.description')}
          </CardDescription>
        </CardHeader>
        <CardContent className='px-6'>
          <LoginForm />
        </CardContent>
      </Card>
    </div>
  );
};

export default Login;
